<template>
  <div class="correlationInform">
    <div class="table">
      <el-table
        :header-cell-style="{ background: '#fff', color: '#333333' }"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @sort-change="changeTableSort"
      >
        <el-table-column
          sortable="custom"
          label="序号"
          prop="序号"
          width="180"
          align="center"
          type="index"
        >
          <!-- <template slot-scope="scope">{{ scope.row.date }}</template> -->
        </el-table-column>

        <el-table-column label="标题" prop="标题" align="center">
          <template slot-scope="scope">{{ scope.row.title }}</template>
        </el-table-column>

        <el-table-column label="资讯类型" prop="资讯类型" align="center">
          <template slot-scope="scope">{{ scope.row.informationType }}</template>
        </el-table-column>
        <el-table-column label="爬取网站" prop="爬取网站" align="center">
          <template slot-scope="scope">{{ scope.row.gainSites }}</template>
        </el-table-column>

        <el-table-column label="关键词" prop="关键词" align="center">
          <template slot-scope="scope">{{ scope.row.keyword }}</template>
        </el-table-column>

        <el-table-column sortable="custom" label="发布时间" prop="发布时间" align="center">
          <template slot-scope="scope">{{ scope.row.releaseTime }}</template>
        </el-table-column>

        <el-table-column label="操作" prop="操作" align="center">
          <template slot-scope="scope">
            <div @click="clickToInform(scope.row)" class="clickToInform">详情</div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="1"
        :page-sizes="[10, 30, 50]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { getConsulting } from '../../../../api/businessCenter.js'
export default {
  components: {},
  data() {
    //这里存放数据
    return {
      tableData: [],
      total: 0,
      row: {},
      query: {
        baseParam: {
          pageNum: 1,
          pageSize: 10
        },
        clueCode: '',
        id: null,
        order: 'desc'
      }
    }
  },

  computed: {},

  watch: {},
  created() {
    let row1 = sessionStorage.getItem('row1')
    if (row1) {
      this.row = JSON.parse(row1)
    } else {
      this.row = JSON.parse(this.$route.query.row)
    }
    this.search()
  },
  methods: {
    async search() {
      const { data: res } = await getConsulting(this.query)

      this.$emit('quantity', res.data.total)
    },
    // 表格排序
    changeTableSort(column) {
      console.log(column)
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`)
    },
    // 去详情
    clickToInform(row) {
      this.$router.push({
        path: '/businessCenter/clueCenter/informationMessage',
        query: {
          id: row.id
        }
      })
    }
  },

  mounted() {}
}
</script>
<style scoped lang="less">
.correlationInform {
  background-color: #fff;
  padding-top: 20px;

  .pagination {
    width: 100%;
    height: 120px;
    background-color: #fff;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .clickToInform {
    color: #17757a;
    font-size: 14px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
}
</style>
